import ProductionCompanyDTO from '@src/adapters/dto/productionCompany/ProductionCompanyDTO';
import useCachedList from '../base/useCachedList';
import useFindProductionCompaniesListLazy from './useFindProductionCompaniesList';

type FindLazyResult = { items: ProductionCompanyDTO[] };

const useCachedProductionCompanyList = () => {
  return useCachedList<ProductionCompanyDTO, FindLazyResult>(
    'productionCompanyList',
    useFindProductionCompaniesListLazy,
    'items'
  );
};

export default useCachedProductionCompanyList;
